import { ReportDesignerWidgetCategoryDefinition } from "./models/report-designer-widget-category-definition";

export const widgetDefinitions: ReportDesignerWidgetCategoryDefinition[] = [
  {
    text: "Report Elements",
    items: [
      {
        WidgetTemplateName: "Widget Line - red",
        WidgetNameEnglish: "Widget Line - red",
        config: {
          title: "Widget Line - red",
          widgetId: -349,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 3,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-full-line widget-config='widget'></widget-full-line>",
          noComment: true,
          widgetSettings: {
            widgetBackgroundColorClass: "widget-full-line-title-color-red",
            id: "-22",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "Widget Line - dark grey",
        WidgetNameEnglish: "Widget Line - dark grey",
        config: {
          title: "Widget Line - dark grey",
          widgetId: -350,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 3,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-full-line widget-config='widget'></widget-full-line>",
          noComment: true,
          widgetSettings: {
            widgetBackgroundColorClass: "widget-full-line-title-color-dark-grey",
            id: "-23",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "Widget Line - light grey",
        WidgetNameEnglish: "Widget Line - light grey",
        config: {
          title: "Widget Line - light grey",
          widgetId: -348,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 3,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-full-line widget-config='widget'></widget-full-line>",
          noComment: true,
          widgetSettings: {
            widgetBackgroundColorClass: "widget-full-line-title-color-light-grey",
            id: "-21",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "Widget Line - light grey solid",
        WidgetNameEnglish: "Widget Line - light grey solid",
        config: {
          title: "Widget Line - light grey solid",
          widgetId: -42,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 3,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-full-line widget-config='widget'></widget-full-line>",
          noComment: true,
          widgetSettings: {
            widgetBackgroundColorClass: "widget-full-line-title-color-light-grey-solid",
            id: "-42",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "Widget Line - slate",
        WidgetNameEnglish: "Widget Line - slate",
        config: {
          title: "Widget Line - slate",
          widgetId: -347,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 3,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-full-line widget-config='widget'></widget-full-line>",
          noComment: true,
          widgetSettings: {
            widgetBackgroundColorClass: "widget-full-line-title-color-slate",
            id: "-20",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "Widget Main Section Title",
        WidgetNameEnglish: "Widget Main Section Title",
        config: {
          title: "Widget Main Section Title",
          widgetId: -360,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 2,
          minSizeX: 6,
          maxSizeY: 3,
          minSizeY: 2,
          sizeXL: 17,
          sizeYL: 1,
          minSizeXL: 17,
          minSizeYL: 1,
          template: "<widget-main-section-title widget-config='widget'></widget-main-section-title>",
          noComment: true,
          widgetSettings: {
            id: "-24",
            enabledButtonInfobar: false,
            title: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      }
    ]
  },
  {
    text: "OneReport",
    items: [
      {
        WidgetTemplateName: "TextWidget",
        WidgetNameEnglish: "Text",
        downgradedName: "textWidget",
        config: {
          isProperty: true,
          title: "Text",
          col: 0,
          widgetId: 140,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 3,
          sizeXL: 5,
          sizeYL: 4,
          multipleInstances: true,
          template: "<text-widget widget-config='widget'></text-widget>",
          widgetSettings: {
            id: "140",
            hasKendoEditor: true,
            currentLayout: "ChosenOnAdd",
            maxLayouts: 318
          },
          oneInstancePerLayout: true,
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "RentKPI",
        WidgetNameEnglish: "Rent KPI",
        downgradedName: "rentKpiWidget",
        config: {
          title: "Rent KPI",
          col: 0,
          widgetId: 24,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 4,
          sizeY: 6,
          minSizeX: 4,
          minSizeY: 6,
          template: "<rent-kpi-widget widget-config='widget'></rent-kpi-widget>",
          widgetSettings: {
            id: "24"
          }
        }
      },
      {
        WidgetTemplateName: "TownPlanning",
        WidgetNameEnglish: "Planning Regulations",
        downgradedName: "townPlanningWidget",
        config: {
          title: "Planning Regulations",
          col: 0,
          widgetId: 22,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 16,
          minSizeX: 3,
          minSizeY: 16,
          template: "<town-planning-widget widget-config='widget'></town-planning-widget>",
          widgetSettings: {
            id: "22"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "SiteInformation",
        WidgetNameEnglish: "Site Information",
        downgradedName: "siteInformationWidget",
        config: {
          title: "Site Information",
          col: 0,
          widgetId: 19,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 18,
          minSizeX: 3,
          minSizeY: 18,
          template: "<site-information-widget widget-config='widget'></site-information-widget>",
          widgetSettings: {
            id: "19",
            rows: 11,
            rowsArray: [],
            layoutSizeConfiguration: {
              "edit": {
                "y": 19
              },
              "view": {
                "y": 14
              }
            }
          }
        }
      },
      {
        WidgetTemplateName: "SensitivityAnalysis",
        WidgetNameEnglish: "Sensitivity Analysis",
        config: {
          title: "Sensitivity Analysis",
          col: 0,
          widgetId: 1000,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 15,
          minSizeX: 6,
          minSizeY: 15,
          template: "<sensitivity-analysis-widget widget-config='widget'></sensitivity-analysis-widget>",
          widgetSettings: {
            id: "1000"
          }
        }
      },
      {
        WidgetTemplateName: "KeyFiguresScenario",
        WidgetNameEnglish: "Key Figures",
        downgradedName: "keyFiguresWidget",
        config: {
          title: "Key Figures",
          col: 0,
          widgetId: 4274,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 38,
          minSizeX: 3,
          minSizeY: 36,
          autoScale: true,
          template: "<key-figures-widget widget-config='widget'></key-figures-widget>",
          multipleInstances: false,
          widgetSettings: {
            id: "4274",
            currentLayout: "Trad Val",
            availableLayouts: [
              "Trad Val",
              "DCF"
            ],
            layoutSizeConfiguration: {
              "Trad Val": {
                "x": 3,
                "y": 38
              },
              "DCF": {
                "x": 3,
                "y": 36
              }
            }
          }
        }
      },
      {
        WidgetTemplateName: "LocalMarketData",
        WidgetNameEnglish: "Local Market Data Leasing",
        downgradedName: "localMarketDataWidget",
        config: {
          title: "Local Market Data Leasing",
          widgetId: 9,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 7,
          minSizeX: 6,
          minSizeY: 7,
          template: "<local-market-data-widget widget-config='widget'></local-market-data-widget>",
          widgetSettings: {
            id: "9"
          }
        }
      },
      {
        WidgetTemplateName: "MacroLocationFigures",
        WidgetNameEnglish: "Macro Location",
        downgradedName: "macroLocationFiguresWidget",
        config: {
          title: "Macro Location",
          col: 0,
          widgetId: 2842,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 11,
          minSizeX: 3,
          minSizeY: 11,
          template: "<macro-location-figures-widget widget-config='widget'></macro-location-figures-widget>",
          widgetSettings: {
            id: "2842"
          }
        }
      },
      {
        WidgetTemplateName: "HRentRoll",
        WidgetNameEnglish: "Rent Roll",
        downgradedName: "hrentrollWidget",
        config: {
          title: "Rent Roll",
          widgetId: 71,
          supportsPortrait: false,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 5,
          minSizeX: 6,
          minSizeY: 5,
          sizeXL: 17,
          sizeYL: 17,
          minSizeXL: 17,
          minSizeYL: 16,
          template: "<hrentroll-widget widget-config='widget'></hrentroll-widget>",
          widgetSettings: {
            id: "71",
            currentLayout: "Default",
            availableLayouts: [
              "Default"
            ]
          },
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "HCashFlowMarketValue",
        WidgetNameEnglish: "Cashflow",
        downgradedName: "hCashFlowWidget",
        config: {
          title: "Cashflow",
          widgetId: 42009,
          supportsPortrait: false,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 16,
          minSizeX: 6,
          minSizeY: 16,
          sizeXL: 17,
          sizeYL: 16,
          minSizeXL: 17,
          minSizeYL: 16,
          template: "<h-cash-flow-widget widget-config='widget'></h-cash-flow-widget>",
          multipleInstances: false,
          widgetSettings: {
            id: "42009",
            currentLayout: "Summary",
            availableLayouts: [
              "Summary",
              "Detailed"
            ]
          },
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "PropertyAnalysisScenario",
        WidgetNameEnglish: "Property Analysis",
        downgradedName: "propertyAnalysisWidget",
        config: {
          title: "Property Analysis",
          col: 0,
          widgetId: 16,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 34,
          minSizeX: 6,
          minSizeY: 6,
          template: "<property-analysis-widget widget-config='widget'></property-analysis-widget>",
          widgetSettings: {
            id: "16",
            currentLayout: "Small",
            availableLayouts: [
              "Small",
              "Large"
            ],
            layoutSizeConfiguration: {
              "Small": {
                "x": 6,
                "y": 34
              },
              "Large": {
                "x": 6,
                "y": 59
              }
            }
          },
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "SWOT",
        WidgetNameEnglish: "SWOT",
        downgradedName: "swotWidget",
        config: {
          title: "SWOT",
          col: 0,
          widgetId: 150,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 22,
          minSizeX: 6,
          minSizeY: 22,
          template: "<swot-widget widget-config='widget'></swot-widget>",
          widgetSettings: {
            id: "15"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "PictureWidget",
        WidgetNameEnglish: "Picture",
        downgradedName: "pictureWidget",
        config: {
          title: "Picture",
          widgetId: 400,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 3,
          sizeY: 27,
          minSizeX: 3,
          minSizeY: 26,
          autoScale: true,
          template: "<picture-widget widget-config='widget'></picture-widget>",
          widgetSettings: {
            id: "400",
            currentLayout: "Cover",
            hideCheckoutNotification: true,
            availableLayouts: []
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "InvestmentComparablesWidget",
        WidgetNameEnglish: "Investment Comparables",
        downgradedName: "investmentComparablesWidget",
        config: {
          title: "Investment Comparables",
          widgetId: 12554,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 16,
          minSizeX: 6,
          minSizeY: 3,
          template: "<investment-comparables-widget widget-config='widget'></investment-comparables-widget>",
          widgetSettings: {
            id: "12554",
            showButtonGetPixCompsData: true,
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Short"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "PropertyDetailsWidget",
        WidgetNameEnglish: "Property Details",
        downgradedName: "propertyDetailsWidget",
        config: {
          title: "Property Details",
          widgetId: 12553,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 7,
          minSizeX: 6,
          minSizeY: 7,
          template: "<property-details-widget widget-config='widget'></property-details-widget>",
          widgetSettings: {
            id: "12553"
          }
        }
      },
      {
        WidgetTemplateName: "Inspection",
        WidgetNameEnglish: "Inspection & Sign off",
        config: {
          title: "Inspection & Sign off",
          col: 0,
          widgetId: 402,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 13,
          sizeXL: 15,
          sizeYL: 7,
          template: "<inspection-widget widget-config='widget'></inspection-widget>",
          widgetSettings: {
            id: "402"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "Appendix",
        WidgetNameEnglish: "Appendices Overview",
        downgradedName: "appendixWidget",
        config: {
          title: "Appendices Overview",
          col: 0,
          widgetId: 1120,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 18,
          minSizeX: 6,
          minSizeY: 3,
          template: "<appendix-widget widget-config='widget'></appendix-widget>",
          widgetSettings: {
            id: "1120"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "Key Tenants",
        WidgetNameEnglish: "Key Tenants",
        downgradedName: "keyTenantsWidget",
        config: {
          title: "Key Tenants",
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 22,
          widgetId: 36,
          template: "<key-tenants-widget widget-config='widget'></key-tenants-widget>",
          widgetSettings: {
            id: "36",
            currentLayout: "with WALB",
            availableLayouts: [
              "with WALB",
              "without WALB"
            ]
          }
        }
      },
      {
        WidgetTemplateName: "ESG",
        WidgetNameEnglish: "ESG",
        downgradedName: "esgWidget",
        WidgetType: "full",
        config: {
          title: "ESG",
          col: 0,
          widgetId: 1001,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 93,
          minSizeX: 6,
          minSizeY: 0,
          template: "<esg-widget widget-config='widget'></esg-widget>",
          widgetSettings: {
            id: "1001"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "EsgInteriorDescription",
        WidgetNameEnglish: "ESG Interior Description / Office",
        downgradedName: "esgInteriorDescriptionWidget",
        config: {
          title: "ESG Interior Description / Office",
          col: 0,
          widgetId: 1121,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 32,
          minSizeX: 6,
          minSizeY: 3,
          template: "<esg-interior-description-widget widget-config='widget'></esg-interior-description-widget>",
          widgetSettings: {
            id: "1121"
          },
          hashtagSupported: false
        }
      },

      {
        WidgetTemplateName: "EsgExteriorDescription",
        WidgetNameEnglish: "ESG Exterior Description",
        downgradedName: "esgExteriorDescriptionWidget",
        config: {
          title: "ESG Exterior Description",
          col: 0,
          widgetId: 11222,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 36,
          minSizeX: 6,
          minSizeY: 3,
          template: "<esg-exterior-description-widget widget-config='widget'></esg-exterior-description-widget>",
          widgetSettings: {
            id: "11222"
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "ValuationSummary",
        WidgetNameEnglish: "Valuation Summary",
        downgradedName: "valuationSummaryWidget",
        config: {
          title: "Valuation Summary",
          col: 0,
          widgetId: 1122,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 8,
          minSizeX: 6,
          minSizeY: 8,
          template: "<valuation-summary-widget widget-config='widget'></valuation-summary-widget>",
          widgetSettings: {
            id: "1122",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Short"
            ]
          }
        }
      },
      {
        WidgetTemplateName: "PeriodOverPeriod",
        WidgetNameEnglish: "Period over Period",
        downgradedName: "periodOverPeriodWidget",
        config: {
          title: "Period over Period",
          col: 0,
          widgetId: 1131,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 42,
          minSizeX: 6,
          minSizeY: 3,
          template: "<period-over-period-widget widget-config='widget'></period-over-period-widget>",
          widgetSettings: {
            id: "1131",
            currentLayout: "Trad Val",
            availableLayouts: [
              "Trad Val",
              "DCF"
            ],
            hasSlideOut: true
          }
        }
      },
      {
        WidgetTemplateName: "EsgCriteria",
        WidgetNameEnglish: "ESG Criteria",
        downgradedName: "esgCriteriaWidget",
        config: {
          title: "ESG Criteria",
          col: 0,
          widgetId: 1123,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 34,
          minSizeX: 6,
          minSizeY: 3,
          template: "<esg-criteria-widget widget-config='widget'></esg-criteria-widget>",
          widgetSettings: {
            id: "1123"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "LeasingComparables",
        WidgetNameEnglish: "Leasing Comparables",
        downgradedName: "leasingComparablesWidget",
        config: {
          title: "Leasing Comparables",
          widgetId: 32,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 6,
          minSizeY: 3,
          template: "<leasing-comparables-widget widget-config='widget'></leasing-comparables-widget>",
          widgetSettings: {
            id: "32",
            showButtonGetPixCompsData: true
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "CapitalExpenditureWidget",
        WidgetNameEnglish: "Capital Expenditure (CapEX)",
        downgradedName: "capitalExpenditureWidget",
        config: {
          title: "Capital Expenditure  (CapEX)",
          widgetId: 12558,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 46,
          minSizeX: 6,
          minSizeY: 32,
          template: "<capital-expenditure-widget widget-config='widget'></capital-expenditure-widget>",
          widgetSettings: {
            id: "12558",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "LettingAssumptionsWidget",
        WidgetNameEnglish: "Letting Assumptions",
        downgradedName: "lettingAssumptionsWidget",
        config: {
          title: "Letting Assumptions",
          widgetId: 12565,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 27,
          minSizeX: 6,
          minSizeY: 27,
          template: "<letting-assumptions-widget widget-config='widget'></letting-assumptions-widget>",
          widgetSettings: {
            id: "12565"
          },
          hashtagSupported: true

        }
      },
      {
        WidgetTemplateName: "ValuationResults3",
        WidgetNameEnglish: "Valuation Results",
        downgradedName: "valuationResults3Widget",
        config: {
          title: "Valuation Results",
          col: 0,
          widgetId: 13559,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 11,
          minSizeX: 3,
          minSizeY: 11,
          multipleInstances: true,
          template: "<valuation-results3-widget widget-config='widget'></valuation-results3-widget>",
          widgetSettings: {
            id: "13559",
            currentLayout: "DCF",
            availableLayouts: [
              "DCF",
              "Trad Val"
            ],
            layoutSizeConfiguration: {
              "DCF": {
                "x": 6,
                "y": 11
              },
              "Trad Val": {
                "x": 6,
                "y": 12
              }
            },
            "buttonCostsOfSale": {
              show: true
            }
          }
        }
      },
      {
        WidgetTemplateName: "GrowthRateInflationIndexation",
        WidgetNameEnglish: "Growth Rate, Inflation, Indexation",
        downgradedName: "dcfGrowthRateInflationIndexWidget",
        config: {
          title: "Growth Rate, Inflation, Indexation",
          col: 0,
          widgetId: 33,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 49,
          minSizeX: 3,
          minSizeY: 6,
          template: "<dcf-growth-rate-inflation-index-widget widget-config='widget'></dcf-growth-rate-inflation-index-widget>",
          widgetSettings: {
            id: "33",
            currentLayout: "Large",
            availableLayouts: [
              "Large",
              "Small"
            ],
            layoutSizeConfiguration: {
              "Large": {
                "x": 6,
                "y": 49
              },
              "Small": {
                "x": 6,
                "y": 23
              }
            }
          }
        }
      },
      {
        WidgetTemplateName: "CountrySpecifics",
        WidgetNameEnglish: "Country Specifics",
        downgradedName: "countrySpecificsWidget",
        config: {
          title: "Country Specifics",
          widgetId: 38,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 53,
          minSizeX: 6,
          minSizeY: 3,
          template: "<country-specifics-widget widget-config='widget'></country-specifics-widget>",
          widgetSettings: {
            id: "38"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "CountrySpecificsHighestAndBestUse",
        WidgetNameEnglish: "Country Specifics - Highest and Best Use",
        downgradedName: "countrySpecificsHighestAndBestUseWidget",
        config: {
          title: "Country Specifics - Highest and Best Use",
          widgetId: 388,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 14,
          minSizeX: 6,
          minSizeY: 3,
          template: "<country-specifics-highest-and-best-use-widget widget-config='widget'></country-specifics-highest-and-best-use-widget>",
          widgetSettings: {
            id: "388"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "OwnershipAndTransactionHistory",
        WidgetNameEnglish: "Ownership and Transaction History",
        downgradedName: "ownershipAndTransactionHistoryWidget",
        config: {
          title: "Ownership and Transaction History",
          widgetId: 389,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 20,
          minSizeX: 6,
          minSizeY: 3,
          template: "<ownership-and-transaction-history-widget widget-config='widget'></ownership-and-transaction-history-widget>",
          multipleInstances: true,
          oneInstancePerLayout: true,
          dontSortLayouts: true,
          widgetSettings: {
            id: "389",
            currentLayout: "Sale 1",
            availableLayouts: [
              "Sale 1",
              "Sale 2",
              "Sale 3",
              "Sale 4",
              "Sale 5",
              "Sale 6",
              "Sale 7",
              "Sale 8",
              "Sale 9",
              "Sale 10",
              "Sale 11",
              "Sale 12",
              "Sale 13",
              "Sale 14",
              "Sale 15",
              "Sale 16",
              "Sale 17",
              "Sale 18",
              "Sale 19",
              "Sale 20"
            ]
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "ContractSummary",
        WidgetNameEnglish: "Contract Summary",
        downgradedName: "contractSummaryWidget",
        config: {
          title: "Contract Summary",
          widgetId: 39,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 34,
          minSizeX: 6,
          minSizeY: 3,
          template: "<contract-summary-widget widget-config='widget'></contract-summary-widget>",
          widgetSettings: {
            id: "39"
          },
          hashtagSupported: false
        }
      },
      {
        WidgetTemplateName: "LandRegistryTenure",
        WidgetNameEnglish: "Land Registry & Tenure",
        downgradedName: "landRegistryTenureWidget",
        config: {
          title: "Land Registry & Tenure",
          widgetId: 40,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 3,
          sizeY: 27,
          minSizeX: 3,
          minSizeY: 3,
          template: "<land-registry-tenure-widget widget-config='widget'></land-registry-tenure-widget>",
          widgetSettings: {
            id: "40"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "Overall cash flow assumptions",
        WidgetNameEnglish: "Overall cash flow assumptions",
        downgradedName: "overallCashFlowAssumptionsWidget",
        config: {
          title: "Overall cash flow assumptions",
          col: 0,
          widgetId: 11212,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 22,
          minSizeX: 3,
          minSizeY: 3,
          template: "<overall-cash-flow-assumptions-widget widget-config='widget'></overall-cash-flow-assumptions-widget>",
          widgetSettings: {
            id: "11212"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "EsgInteriorDescriptionLogistics",
        WidgetNameEnglish: "ESG Interior Description / Logistics",
        downgradedName: "esgInteriorDescriptionLogisticsWidget",
        config: {
          title: "ESG Interior Description / Logistics",
          widgetId: 41,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 28,
          minSizeX: 3,
          minSizeY: 2,
          template: "<esg-interior-description-logistics-widget widget-config='widget'></esg-interior-description-logistics-widget>",
          widgetSettings: {
            id: "41"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "EsgInteriorDescriptionRetail",
        WidgetNameEnglish: "ESG Interior Description / Retail",
        downgradedName: "esgInteriorDescriptionRetailWidget",
        config: {
          title: "ESG Interior Description / Retail",
          widgetId: 47,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 28,
          minSizeX: 3,
          minSizeY: 2,
          template: "<esg-interior-description-retail-widget widget-config='widget'></esg-interior-description-retail-widget>",
          widgetSettings: {
            id: "47"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "ReportSummary",
        WidgetNameEnglish: "Report Summary",
        downgradedName: "reportSummaryWidget",
        config: {
          title: "Report Summary",
          widgetId: 42,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 15,
          minSizeX: 6,
          minSizeY: 15,
          template: "<report-summary-widget widget-config='widget'></report-summary-widget>",
          widgetSettings: {
            id: "42"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "CoverPage",
        WidgetNameEnglish: "Cover Page",
        downgradedName: "coverPageWidget",
        config: {
          title: "Cover Page",
          widgetId: 43,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 5,
          sizeY: 9,
          minSizeX: 5,
          minSizeY: 9,
          template: "<cover-page-widget widget-config='widget'></cover-page-widget>",
          widgetSettings: {
            id: "43"
          },
          hashtagSupported: false
        }
      },
      {
        WidgetTemplateName: "GrossMarketRentToNetMarketRent",
        WidgetNameEnglish: "ERV to Net Market Rent",
        downgradedName: "grossMarketRentToNetMarketRentWidget",
        config: {
          title: "ERV to Net Market Rent",
          widgetId: 424242,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 30,
          minSizeX: 6,
          minSizeY: 30,
          template: "<gross-market-rent-to-net-market-rent-widget widget-config='widget'></gross-market-rent-to-net-market-rent-widget>",
          widgetSettings: {
            id: "424242"
          },
          hashtagSupported: false
        }
      },
      {
        WidgetTemplateName: "GeneralPricingAssumptions",
        WidgetNameEnglish: "General Pricing Assumptions",
        downgradedName: "generalPricingAssumptionsWidget",
        config: {
          title: "General Pricing Assumptions",
          col: 0,
          widgetId: 1125,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 5,
          minSizeX: 3,
          minSizeY: 3,
          template: "<general-pricing-assumptions-widget widget-config='widget'></general-pricing-assumptions-widget>",
          widgetSettings: {
            id: "1125"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "SocioEconomicData",
        WidgetNameEnglish: "Socio Economic Data",
        downgradedName: "socioEconomicDataWidget",
        config: {
          title: "Socio Economic Data",
          col: 0,
          widgetId: 1126,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 20,
          minSizeX: 3,
          minSizeY: 20,
          template: "<socio-economic-data-widget widget-config='widget'></socio-economic-data-widget>",
          widgetSettings: {
            id: "1126"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "CapitalExpenditureBreakdown",
        WidgetNameEnglish: "Capital Expenditure (Breakdown)",
        downgradedName: "capitalExpenditureBreakdownWidget",
        config: {
          title: "Capital Expenditure (Breakdown)",
          widgetId: 424243,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 53,
          minSizeX: 6,
          minSizeY: 53,
          template: "<capital-expenditure-breakdown-widget widget-config='widget'></capital-expenditure-breakdown-widget>",
          widgetSettings: {
            id: "424243",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "GrossRentToNoi",
        WidgetNameEnglish: "Gross Rent to NOI",
        downgradedName: "grossRentToYear1NoiWidget",
        config: {
          title: "Gross Rent to NOI",
          widgetId: 42424273,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 30,
          minSizeX: 6,
          minSizeY: 30,
          template: "<gross-rent-to-noi-widget widget-config='widget'></gross-rent-to-noi-widget>",
          widgetSettings: {
            id: "42424273"
          },
          hashtagSupported: false
        }
      },
      {
        WidgetTemplateName: "HardcoreTopslice",
        WidgetNameEnglish: "Hardcore & Top Slice",
        downgradedName: "hardcoreTopsliceWidget",
        config: {
          title: "Hardcore & Top Slice",
          widgetId: 125557,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 56,
          minSizeX: 6,
          minSizeY: 52,
          template: "<hardcore-topslice-widget widget-config='widget'></hardcore-topslice-widget>",
          widgetSettings: {
            id: "125557"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "IncomeAnalysis2",
        WidgetNameEnglish: "Income Analysis",
        downgradedName: "incomeAnalysis2Widget",
        config: {
          title: "Income Analysis",
          widgetId: 44,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 28,
          minSizeX: 6,
          minSizeY: 28,
          template: "<income-analysis2-widget widget-config='widget'></income-analysis2-widget>",
          widgetSettings: {
            id: "44"
          },
          hashtagSupported: false,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "LocalMarketDataInvestment",
        WidgetNameEnglish: "Local Market Data Investment",
        downgradedName: "localMarketDataInvestmentWidget",
        config: {
          title: "Local Market Data Investment",
          widgetId: 45,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 8,
          minSizeX: 6,
          minSizeY: 8,
          template: "<local-market-data-investment-widget widget-config='widget'></local-market-data-investment-widget>",
          widgetSettings: {
            id: "45"
          },
          hashtagSupported: false
        }
      },
      {
        WidgetTemplateName: "EstimatedRentalValue",
        WidgetNameEnglish: "Estimated Rental Value",
        downgradedName: "estimatedRentalValueWidget",
        config: {
          title: "Estimated Rental Value",
          widgetId: 46,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 3,
          template: "<estimated-rental-value-widget widget-config='widget'></estimated-rental-value-widget>",
          widgetSettings: {
            id: "46"
          },
          hashtagSupported: false,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "IncomeExitBalanceOfIrr",
        WidgetNameEnglish: "Income / Exit Balance of IRR",
        downgradedName: "incomeExitBalanceOfIrrWidget",
        config: {
          title: "Income / Exit Balance of IRR",
          widgetId: 6873,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 3,
          sizeY: 14,
          minSizeX: 3,
          maxSizeX: 3,
          minSizeY: 14,
          maxSizeY: 14,
          template: "<income-exit-balance-of-irr-widget widget-config='widget'></income-exit-balance-of-irr-widget>",
          widgetSettings: {
            id: "6873"
          }
        }
      },
      {
        WidgetTemplateName: "ServiceChargeNonRecoverablesWidget",
        WidgetNameEnglish: "Service Charge Non Recoverables",
        downgradedName: "serviceChargeNonRecoverablesWidget",
        config: {
          title: "Service Charge Non Recoverables",
          col: 0,
          widgetId: 12764,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 30,
          minSizeX: 3,
          minSizeY: 30,
          template: "<service-charge-non-recoverables-widget widget-config='widget'></service-charge-non-recoverables-widget>",
          multipleInstances: false,
          widgetSettings: {
            id: "12764",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Argus"
            ],
            layoutSizeConfiguration: {
              "Default": {
                "x": 6,
                "y": 30
              },
              "Argus": {
                "x": 3,
                "y": 30
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "PropertyRating",
        WidgetNameEnglish: "Property Rating",
        downgradedName: "propertyRatingWidget",
        config: {
          title: "Property Rating",
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 25,
          widgetId: 17,
          supportsPortrait: true,
          supportsLandscape: false,
          template: "<property-rating-widget widget-config='widget'></property-rating-widget>",
          widgetSettings: {
            id: "17"
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummyFull",
        WidgetNameEnglish: "Table Dummy Full",
        downgradedName: "tableDummyFullWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummy Full",
          col: 0,
          widgetId: 1207,
          supportsPortrait: true,
          supportsLandscape: false,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          dontSortCalculations: true,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 9,
          template: "<table-dummy-full-widget widget-config='widget'></table-dummy-full-widget>",
          widgetSettings: {
            id: "1207",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              }
            },
            currentCalculation: -1,
            maxCalculations: 300,
            hideCalculationLabel: true
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies1Full",
        WidgetNameEnglish: "Table Dummies 1 Full",
        downgradedName: "tableDummies1FullWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 1 Full",
          col: 0,
          widgetId: 207,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 9,
          template: "<table-dummies1-full-widget widget-config='widget'></table-dummies1-full-widget>",
          widgetSettings: {
            id: "207",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies2Full",
        WidgetNameEnglish: "Table Dummies 2 Full",
        downgradedName: "tableDummies2FullWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 2 Full",
          col: 0,
          widgetId: 208,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 9,
          template: "<table-dummies2-full-widget widget-config='widget'></table-dummies2-full-widget>",
          widgetSettings: {
            id: "208",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies3Full",
        WidgetNameEnglish: "Table Dummies 3 Full",
        downgradedName: "tableDummies3FullWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 3 Full",
          col: 0,
          widgetId: 209,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 9,
          template: "<table-dummies3-full-widget widget-config='widget'></table-dummies3-full-widget>",
          widgetSettings: {
            id: "209",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies4Full",
        WidgetNameEnglish: "Table Dummies 4 Full",
        downgradedName: "tableDummies4FullWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 4 Full",
          col: 0,
          widgetId: 210,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 9,
          minSizeX: 6,
          minSizeY: 9,
          template: "<table-dummies4-full-widget widget-config='widget'></table-dummies4-full-widget>",
          widgetSettings: {
            id: "210",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummyHalf",
        WidgetNameEnglish: "Table Dummy Half",
        downgradedName: "tableDummyHalfWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummy Half",
          col: 0,
          widgetId: 1213,
          supportsPortrait: true,
          supportsLandscape: false,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          dontSortCalculations: true,
          row: 0,
          sizeX: 3,
          sizeY: 9,
          minSizeX: 3,
          minSizeY: 9,
          template: "<table-dummy-half-widget widget-config='widget'></table-dummy-half-widget>",
          widgetSettings: {
            id: "1213",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12",
              "16",
              "20"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              },
              "16": {
                "y": 35
              },
              "20": {
                "y": 43
              }
            },
            currentCalculation: -1,
            maxCalculations: 300,
            hideCalculationLabel: true
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies1Half",
        WidgetNameEnglish: "Table Dummies 1 Half",
        downgradedName: "tableDummies1HalfWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 1 Half",
          col: 0,
          widgetId: 213,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 9,
          minSizeX: 3,
          minSizeY: 9,
          template: "<table-dummies1-half-widget widget-config='widget'></table-dummies1-half-widget>",
          widgetSettings: {
            id: "213",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12",
              "16",
              "20"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              },
              "16": {
                "y": 35
              },
              "20": {
                "y": 43
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies2Half",
        WidgetNameEnglish: "Table Dummies 2 Half",
        downgradedName: "tableDummies2HalfWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 2 Half",
          col: 0,
          widgetId: 214,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 9,
          minSizeX: 3,
          minSizeY: 9,
          template: "<table-dummies2-half-widget widget-config='widget'></table-dummies2-half-widget>",
          widgetSettings: {
            id: "214",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12",
              "16",
              "20"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              },
              "16": {
                "y": 35
              },
              "20": {
                "y": 43
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies3Half",
        WidgetNameEnglish: "Table Dummies 3 Half",
        downgradedName: "tableDummies3HalfWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 3 Half",
          col: 0,
          widgetId: 215,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 9,
          minSizeX: 3,
          minSizeY: 9,
          template: "<table-dummies3-half-widget widget-config='widget'></table-dummies3-half-widget>",
          widgetSettings: {
            id: "215",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12",
              "16",
              "20"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              },
              "16": {
                "y": 35
              },
              "20": {
                "y": 43
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "TableDummies4Half",
        WidgetNameEnglish: "Table Dummies 4 Half",
        downgradedName: "tableDummies4HalfWidget",
        WidgetType: "full",
        config: {
          title: "Table Dummies 4 Half",
          col: 0,
          widgetId: 216,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 9,
          minSizeX: 3,
          minSizeY: 9,
          template: "<table-dummies4-half-widget widget-config='widget'></table-dummies4-half-widget>",
          widgetSettings: {
            id: "216",
            currentLayout: "4",
            availableLayouts: [
              "4",
              "8",
              "12",
              "16",
              "20"
            ],
            layoutSizeConfiguration: {
              "4": {
                "y": 9
              },
              "8": {
                "y": 19
              },
              "12": {
                "y": 27
              },
              "16": {
                "y": 35
              },
              "20": {
                "y": 43
              }
            }
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "ClientIntendedUseAndUser",
        WidgetNameEnglish: "Client Intended Use and User",
        downgradedName: "clientIntendedUseAndUserWidget",
        config: {
          title: "Client Intended Use and User",
          widgetId: 1002,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 11,
          minSizeX: 6,
          minSizeY: 11,
          template: "<client-intended-use-and-user-widget widget-config='widget'></client-intended-use-and-user-widget>",
          widgetSettings: {
            id: "1002"
          }
        }
      },
      {
        WidgetTemplateName: "ValueConclusionTable",
        WidgetNameEnglish: "Value Conclusion Table",
        downgradedName: "valueConclusionTableWidget",
        config: {
          title: "Value Conclusion Table",
          widgetId: 2004,
          supportsPortrait: true,
          supportsLandscape: false,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 5,
          minSizeX: 6,
          minSizeY: 5,
          template: "<value-conclusion-table-widget widget-config='widget'></value-conclusion-table-widget>",
          widgetSettings: {
            id: "2004",
            appraisalPremise: "",
            interestAppraised: ""
          },
          multipleInstances: true,
          disableHashtagDefinition: true
        }
      }
    ]
  },
  {
    text: "Residual Value Calculation",
    items: [
      {
        WidgetTemplateName: "CalculationOfThePotentialExitValue",
        WidgetNameEnglish: "Calculation of the Potential Exit Value",
        downgradedName: "calculationOfThePotentialExitValueWidget",
        config: {
          title: "Calculation of the Potential Exit Value",
          col: 0,
          widgetId: 2000,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 3,
          sizeY: 41,
          minSizeX: 3,
          minSizeY: 25,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          template: "<calculation-of-the-potential-exit-value-widget widget-config='widget'></calculation-of-the-potential-exit-value-widget>",
          widgetSettings: {
            id: "2000",
            hasVersionSelection: true,
            hasCalculationSelection: true,
            currentCalculation: 1,
            currentLayout: "LettingScenario",
            availableLayouts: [
              "LettingScenario",
              "SalesScenario",
              "LettingAndSalesScenario"
            ],
            layoutSizeConfiguration: {
              "LettingScenario": {
                "x": 3,
                "y": 42
              },
              "SalesScenario": {
                "x": 3,
                "y": 25
              },
              "LettingAndSalesScenario": {
                "x": 6,
                "y": 62
              }
            },
            availableCalculations: [
              {
                id: 1,
                description: "1"
              },
              {
                id: 2,
                description: "2"
              },
              {
                id: 3,
                description: "3"
              },
              {
                id: 4,
                description: "4"
              }
            ]
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "CapitalExpenditureCalculationOfDevelopmentCosts",
        WidgetNameEnglish: "Calculation of Development Costs",
        downgradedName: "capitalExpenditureCalculationOfDevelopmentCostsWidget",
        config: {
          title: "Calculation of Development Costs",
          col: 0,
          widgetId: 2003,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 94,
          minSizeX: 6,
          minSizeY: 78,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          template: "<capital-expenditure-calculation-of-development-costs-widget widget-config='widget'></capital-expenditure-calculation-of-development-costs-widget>",
          widgetSettings: {
            id: "2003",
            hasVersionSelection: true,
            hasCalculationSelection: true,
            currentCalculation: 1,
            currentLayout: "CG300400Separately",
            availableLayouts: [
              "CG300400Separately",
              "CG300400Together"
            ],
            layoutSizeConfiguration: {
              "CG300400Separately": {
                "x": 6,
                "y": 63
              },
              "CG300400Together": {
                "x": 6,
                "y": 60
              }
            },
            availableCalculations: [
              {
                id: 1,
                description: "1"
              },
              {
                id: 2,
                description: "2"
              },
              {
                id: 3,
                description: "3"
              },
              {
                id: 4,
                description: "4"
              }
            ]
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "ValuationResultsResidual",
        WidgetNameEnglish: "Valuation Results (Residual)",
        downgradedName: "valuationResultsResidualWidget",
        config: {
          title: "Valuation Results (Residual)",
          col: 0,
          widgetId: 2001,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 30,
          minSizeX: 6,
          minSizeY: 1,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          template: "<valuation-results-residual-widget widget-config='widget'></valuation-results-residual-widget>",
          widgetSettings: {
            id: "2001",
            readonly: false,
            hasVersionSelection: true,
            hasCalculationSelection: true,
            currentCalculation: 1,
            availableCalculations: [
              {
                id: 1,
                description: "1"
              },
              {
                id: 2,
                description: "2"
              },
              {
                id: 3,
                description: "3"
              },
              {
                id: 4,
                description: "4"
              }
            ]
          },
          hashtagSupported: true
        }
      },
      {
        WidgetTemplateName: "ValuationResultsResidual",
        WidgetNameEnglish: "Valuation Results (Residual) (Readonly)",
        downgradedName: "valuationResultsResidualWidget",
        config: {
          title: "Valuation Results (Residual)",
          col: 0,
          widgetId: 2002,
          supportsPortrait: true,
          supportsLandscape: false,
          row: 0,
          sizeX: 6,
          sizeY: 30,
          minSizeX: 6,
          minSizeY: 1,
          multipleInstances: true,
          oneInstancePerCalculation: true,
          template: "<valuation-results-residual-widget widget-config='widget'></valuation-results-residual-widget>",
          widgetSettings: {
            id: "2002",
            readonly: true,
            hasVersionSelection: true,
            hasCalculationSelection: true,
            currentCalculation: 1,
            availableCalculations: [
              {
                id: 1,
                description: "1"
              },
              {
                id: 2,
                description: "2"
              },
              {
                id: 3,
                description: "3"
              },
              {
                id: 4,
                description: "4"
              }
            ]
          }
        }
      }
    ]
  },
  {
    text: "US",
    items: [
      {
        WidgetTemplateName: "Signature",
        WidgetNameEnglish: "Signature",
        downgradedName: "signatureWidget",
        config: {
          title: "Signature",
          col: 0,
          widgetId: 124742,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 2,
          sizeY: 15,
          minSizeX: 2,
          minSizeY: 7,
          maxSizeY: 15,
          sizeXL: 3,
          sizeYL: 4,
          template: "<signature-widget widget-config='widget'></signature-widget>",
          multipleInstances: true,
          widgetSettings: {
            id: "124742",
            currentLayout: "ChosenOnAdd",
            availableLayouts: [
              "1",
              "2",
              "3",
              "4"
            ],
          },
          oneInstancePerLayout: true
        }
      },
      {
        WidgetTemplateName: "License",
        WidgetNameEnglish: "License",
        downgradedName: "licenseWidget",
        config: {
          title: "License",
          col: 0,
          widgetId: 124743,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 2,
          sizeY: 14,
          minSizeX: 2,
          minSizeY: 4,
          sizeXL: 3,
          sizeYL: 3,
          "autoScale": true,
          template: "<license-widget widget-config='widget'></license-widget>",
          multipleInstances: true,
          widgetSettings: {
            id: "124743",
            currentLayout: "ChosenOnAdd",
            availableLayouts: [
              "1",
              "2",
              "3",
              "4"
            ],
          },
          oneInstancePerLayout: true
        }
      },
      {
        WidgetTemplateName: "LeaseComparablesSummary",
        WidgetNameEnglish: "Lease Comparables Summary",
        downgradedName: "leaseComparablesSummaryWidget",
        config: {
          title: "Lease Comparables Summary",
          col: 0,
          widgetId: 124744,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 16,
          minSizeX: 4,
          minSizeY: 16,
          sizeXL: 17,
          sizeYL: 17,
          minSizeXL: 8,
          minSizeYL: 17,
          template: "<lease-comparables-summary-widget widget-config='widget'></lease-comparables-summary-widget>",
          widgetSettings: {
            id: "124744"
          }
        }
      },
      {
        WidgetTemplateName: "directCapLeaseExpiration",
        WidgetNameEnglish: "Direct cap lease expiration",
        downgradedName: "directCapLeaseExpirationWidget",
        config: {
          title: "Direct cap lease expiration",
          col: 0,
          widgetId: 124745,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 5,
          minSizeYL: 5,
          template: "<direct-cap-lease-expiration-widget widget-config='widget'></direct-cap-lease-expiration-widget>",
          widgetSettings: {
            id: "124745",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "directCapConclusion",
        WidgetNameEnglish: "Direct cap conclusion",
        downgradedName: "directCapConclusionWidget",
        config: {
          title: "Direct cap conclusion",
          widgetId: 124747,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 96,
          minSizeX: 3,
          minSizeY: 96,
          sizeXL: 6,
          sizeYL: 17,
          minSizeXL: 3,
          minSizeYL: 17,
          template: "<direct-cap-conclusion-widget widget-config='widget'></direct-cap-conclusion-widget>",
          widgetSettings: {
            id: "124747"
          },
          multipleInstances: false
        }
      },
      {
        WidgetTemplateName: "MarketLeasingAssumptions",
        WidgetNameEnglish: "Market Leasing Assumptions",
        downgradedName: "marketLeasingAssumptionsWidget",
        config: {
          title: "Market Leasing Assumptions",
          col: 0,
          widgetId: 124746,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 27,
          minSizeX: 4,
          minSizeY: 27,
          sizeXL: 17,
          sizeYL: 10,
          minSizeXL: 9,
          minSizeYL: 10,
          template: "<market-leasing-assumptions-widget widget-config='widget'></market-leasing-assumptions-widget>",
          widgetSettings: {
            id: "124746"
          }
        }
      },
      {
        WidgetTemplateName: "capRateCalculations",
        WidgetNameEnglish: "Capitalization rate calculations",
        downgradedName: "capRateCalculationsWidget",
        config: {
          title: "Capitalization rate calculations",
          col: 0,
          widgetId: 124365,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 35,
          minSizeX: 3,
          minSizeY: 35,
          sizeXL: 17,
          sizeYL: 9,
          minSizeXL: 8,
          minSizeYL: 9,
          template: "<cap-rate-calculations-widget widget-config='widget'></cap-rate-calculations-widget>",
          widgetSettings: {
            id: "124365",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "LeaseSummary",
        WidgetNameEnglish: "Lease Summary",
        downgradedName: "leaseSummaryWidget",
        config: {
          title: "Lease Summary",
          widgetId: 48,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 52,
          minSizeX: 4,
          minSizeY: 52,
          sizeXL: 17,
          sizeYL: 15,
          minSizeXL: 8,
          minSizeYL: 15,
          template: "<lease-summary-widget widget-config='widget'></lease-summary-widget>",
          multipleInstances: true,
          oneInstancePerLayout: true,
          dontSortLayouts: true,
          widgetSettings: {
            id: "48",
            currentLayout: "ChosenOnAdd",
            availableLayouts: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10"
            ],
          }
        }
      },
      {
        WidgetTemplateName: "MiscRevenue",
        WidgetNameEnglish: "Miscellaneous Revenue",
        downgradedName: "miscRevenueWidget",
        config: {
          title: "Miscellaneous Revenue",
          widgetId: 50,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 4,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 3,
          minSizeXL: 8,
          minSizeYL: 3,
          template: "<misc-revenue-widget widget-config='widget'></misc-revenue-widget>",
          multipleInstances: false,
          widgetSettings: {
            id: "50"
          }
        }
      },
      {
        WidgetTemplateName: "TenantRollover",
        WidgetNameEnglish: "Tenant Rollover",
        downgradedName: "tenantRolloverWidget",
        config: {
          title: "Tenant Rollover",
          col: 0,
          widgetId: 4275,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 40,
          minSizeX: 4,
          minSizeY: 40,
          sizeXL: 17,
          sizeYL: 10,
          minSizeXL: 8,
          minSizeYL: 10,
          template: "<tenant-rollover-widget widget-config='widget'></tenant-rollover-widget>",
          multipleInstances: true,
          widgetSettings: {
            id: "4275",
            currentLayout: "ChosenOnAdd",
            availableLayouts: [
              "1",
              "2",
              "3",
            ]
          },
          oneInstancePerLayout: true
        }
      },
      {
        WidgetTemplateName: "NoiProjection",
        WidgetNameEnglish: "Noi Projection",
        downgradedName: "noiProjectionWidget",
        config: {
          title: "Noi Projection",
          col: 0,
          widgetId: 4276,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 3,
          sizeY: 36,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 6,
          sizeYL: 17,
          minSizeXL: 3,
          minSizeYL: 17,
          template: "<noi-projection-widget widget-config='widget'></noi-projection-widget>",
          widgetSettings: {
            id: "4276"
          }
        }
      },
      {
        WidgetTemplateName: "historyAndProjections",
        WidgetNameEnglish: "History and projections",
        downgradedName: "historyAndProjectionsWidget",
        config: {
          title: "History and projections",
          col: 0,
          widgetId: 124802,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 21,
          minSizeX: 4,
          minSizeY: 21,
          sizeXL: 17,
          sizeYL: 10,
          minSizeXL: 8,
          minSizeYL: 10,
          template: "<history-and-projections-widget widget-config='widget'></history-and-projections-widget>",
          widgetSettings: {
            id: "124802"
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "effectiveGrossIncome",
        WidgetNameEnglish: "Effective gross income",
        downgradedName: "effectiveGrossIncomeWidget",
        config: {
          title: "Effective gross income",
          col: 0,
          widgetId: 147930,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 3,
          minSizeXL: 5,
          minSizeYL: 3,
          template: "<effective-gross-income-widget widget-config='widget'></effective-gross-income-widget>",
          widgetSettings: {
            id: "147930",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "DirectCapPGIOccupiedSpace",
        WidgetNameEnglish: "Direct Cap PGI Occupied Space",
        downgradedName: "directCapPGIOccupiedSpaceWidget",
        config: {
          title: "Direct Cap PGI Occupied Space",
          col: 0,
          widgetId: 124777,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 8,
          minSizeYL: 5,
          template: "<direct-cap-pgi-occupied-space-widget widget-config='widget'></direct-cap-pgi-occupied-space-widget>",
          widgetSettings: {
            id: "124745",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "DirectCapPGIVacantSpace",
        WidgetNameEnglish: "Direct Cap PGI Vacant Space",
        downgradedName: "directCapPGIVacantSpaceWidget",
        config: {
          title: "Direct Cap PGI Vacant Space",
          col: 0,
          widgetId: 124778,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 8,
          minSizeYL: 5,
          template: "<direct-cap-pgi-vacant-space-widget widget-config='widget'></direct-cap-pgi-vacant-space-widget>",
          widgetSettings: {
            id: "124745",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "DirectCapPGISummary",
        WidgetNameEnglish: "Direct Cap PGI Summary",
        downgradedName: "directCapPGISummaryWidget",
        config: {
          title: "Direct Cap PGI Summary",
          col: 0,
          widgetId: 124779,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 8,
          minSizeYL: 5,
          template: "<direct-cap-pgi-summary-widget widget-config='widget'></direct-cap-pgi-summary-widget>",
          widgetSettings: {
            id: "124745",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "ExpertSurvey",
        WidgetNameEnglish: "Expert Survey",
        downgradedName: "expertSurveyWidget",
        config: {
          title: "Expert Survey",
          col: 0,
          widgetId: 147931,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 4,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 6,
          minSizeXL: 8,
          minSizeYL: 6,
          template: "<expert-survey-widget widget-config='widget'></expert-survey-widget>",
          widgetSettings: {
            id: "147931"
          }
        }
      },
      {
        WidgetTemplateName: "DirectCapExpenseComps",
        WidgetNameEnglish: "Direct Cap - Expense Comps",
        downgradedName: "directCapExpenseCompsWidget",
        config: {
          title: "Direct Cap - Expense Comps",
          col: 0,
          widgetId: 4278,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 35,
          minSizeX: 4,
          minSizeY: 35,
          sizeXL: 17,
          sizeYL: 11,
          minSizeXL: 8,
          minSizeYL: 11,
          template: "<direct-cap-expense-comps-widget widget-config='widget'></direct-cap-expense-comps-widget>",
          widgetSettings: {
            id: "4278",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "InvestorSurveys",
        WidgetNameEnglish: "Investor Surveys",
        downgradedName: "investorSurveysWidget",
        config: {
          title: "Investor Surveys",
          col: 0,
          widgetId: 4279,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 10,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 3,
          minSizeXL: 5,
          minSizeYL: 3,
          template: "<investor-surveys-widget widget-config='widget'></investor-surveys-widget>",
          widgetSettings: {
            id: "4279",
            currentLayout: "Default",
            availableLayouts: [
              "Default",
              "Manual Input"
            ]
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "CapRateComps",
        WidgetNameEnglish: "Cap Rate Comps",
        downgradedName: "capRateCompsWidget",
        config: {
          title: "Cap rate comps",
          col: 0,
          widgetId: 4277,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 20,
          minSizeX: 4,
          minSizeY: 20,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 9,
          minSizeYL: 5,
          template: "<cap-rate-comps-widget widget-config='widget'></cap-rate-comps-widget>",
          widgetSettings: {
            id: "4277"
          },
          hashtagSupported: true,
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "CapRateReconciliation",
        WidgetNameEnglish: "Cap Rate Reconciliation",
        downgradedName: "capRateReconciliationWidget",
        config: {
          title: "Cap Rate Reconciliation",
          col: 0,
          widgetId: 147932,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 18,
          minSizeX: 3,
          minSizeY: 18,
          sizeXL: 17,
          sizeYL: 5,
          minSizeXL: 6,
          minSizeYL: 5,
          template: "<cap-rate-reconciliation-widget widget-config='widget'></cap-rate-reconciliation-widget>",
          widgetSettings: {
            id: "147932"
          }
        }
      },
      {
        WidgetTemplateName: "DirectCapHRentRoll",
        WidgetNameEnglish: "Rent Roll",
        downgradedName: "directCapHrentrollWidget",
        config: {
          title: "Rent Roll",
          widgetId: 712,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 6,
          sizeY: 41,
          minSizeX: 6,
          minSizeY: 5,
          sizeXL: 17,
          sizeYL: 17,
          minSizeXL: 17,
          minSizeYL: 16,
          template: "<direct-cap-hrentroll-widget widget-config='widget'></direct-cap-hrentroll-widget>",
          widgetSettings: {
            id: "712",
            currentLayout: "US rent roll",
            availableLayouts: [
              "US rent roll"
            ]
          },
          disableHashtagDefinition: true
        }
      },
      {
        WidgetTemplateName: "LeaseUpCosts",
        WidgetNameEnglish: "Lease Up Costs",
        downgradedName: "leaseUpCostsWidget",
        config: {
          title: "Lease Up Costs",
          col: 0,
          widgetId: 4280,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 23,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 17,
          sizeYL: 10,
          minSizeXL: 17,
          minSizeYL: 3,
          template: "<lease-up-costs-widget widget-config='widget'></lease-up-costs-widget>",
          widgetSettings: {
            id: "4280"
          }
        }
      },
      {
        WidgetTemplateName: "ImprovedSalesMap",
        WidgetNameEnglish: "Improved Sales Map",
        downgradedName: "improvedSalesMapWidget",
        config: {
          title: "Improved Sales Map",
          col: 0,
          widgetId: 4281,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 3,
          sizeY: 26,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 7,
          sizeYL: 7,
          template: "<improved-sales-map-widget widget-config='widget'></improved-sales-map-widget>",
          widgetSettings: {
            id: "4281"
          }
        }
      },
      {
        WidgetTemplateName: "ImprovedSalesSummary",
        WidgetNameEnglish: "Improved Sales Summary",
        downgradedName: "improvedSalesSummaryWidget",
        config: {
          title: "Improved Sales Summary",
          col: 0,
          widgetId: 4282,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 23,
          minSizeX: 5,
          minSizeY: 23,
          sizeXL: 17,
          sizeYL: 17,
          minSizeXL: 10,
          minSizeYL: 17,
          template: "<improved-sales-summary-widget widget-config='widget'></improved-sales-summary-widget>",
          widgetSettings: {
            id: "4282"
          }
        }
      },
      {
        WidgetTemplateName: "DirectCapLeaseCompsMap",
        WidgetNameEnglish: "Direct Cap Lease Comps Map",
        downgradedName: "directCapLeaseCompsMapWidget",
        config: {
          title: "Direct Cap Lease Comps Map",
          col: 0,
          widgetId: 4283,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 3,
          sizeY: 26,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 7,
          sizeYL: 7,
          template: "<direct-cap-lease-comps-map-widget widget-config='widget'></direct-cap-lease-comps-map-widget>",
          widgetSettings: {
            id: "4283"
          }
        }
      },
      {
        WidgetTemplateName: "SalesGrid",
        WidgetNameEnglish: "Sales Grid",
        downgradedName: "salesGridWidget",
        config: {
          title: "Sales Grid",
          col: 0,
          widgetId: 4284,
          supportsPortrait: true,
          supportsLandscape: true,
          row: 0,
          sizeX: 6,
          sizeY: 23,
          minSizeX: 4,
          minSizeY: 23,
          sizeXL: 17,
          sizeYL: 17,
          minSizeXL: 9,
          minSizeYL: 17,
          template: "<sales-grid-widget widget-config='widget'></sales-grid-widget>",
          widgetSettings: {
            id: "4284"
          }
        }
      },
      {
        WidgetTemplateName: "SalesApproachValuation",
        WidgetNameEnglish: "Sales Approach Valuation",
        downgradedName: "salesApproachValuationWidget",
        config: {
          title: "Sales Approach Valuation",
          widgetId: 4285,
          supportsPortrait: true,
          supportsLandscape: true,
          col: 0,
          row: 0,
          sizeX: 3,
          sizeY: 72,
          minSizeX: 3,
          minSizeY: 10,
          sizeXL: 6,
          sizeYL: 17,
          minSizeXL: 4,
          minSizeYL: 17,
          template: "<sales-approach-valuation-widget widget-config='widget'></sales-approach-valuation-widget>",
          widgetSettings: {
            id: "4285"
          }
        }
      }
    ]
  }
]
